import { EditOutlined } from '@ant-design/icons';
import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { Button, List, Tooltip, Typography } from 'antd';
import { useMemo } from 'react';
import { type IMapLayer } from '../layers/MapLayer.ts';

export interface IMapCompetencesConfigSectionProps {
  layersEditor: RelationEditor<IMapLayer>;
}

/**
 * Sezione nel configuratore widget mappa che mostra l'elenco
 * delle competenze configurate per-layer.
 */
export function MapCompetencesConfigSection(
  props: IMapCompetencesConfigSectionProps,
) {
  const { layersEditor } = props;

  const competenceLayers = useMemo(
    () => layersEditor.items.filter(layer => layer.competence?.enabled),
    [layersEditor.items],
  );

  return (
    <div>
      <Typography.Paragraph>
        Elenco dei livelli con competenza abilitata. Per modificare una
        competenza, apri la configurazione del livello corrispondente.
      </Typography.Paragraph>

      <List
        size="small"
        dataSource={competenceLayers}
        locale={{ emptyText: 'Nessuna competenza configurata' }}
        renderItem={layer => {
          const competence = layer.competence!;
          const roleLabel =
            competence.role === 'primary' ? 'Primaria' : 'Secondaria';

          return (
            <List.Item
              actions={[
                <Tooltip title="Modifica" key="edit">
                  <Button
                    size="small"
                    type="text"
                    aria-label="Modifica competenza"
                    icon={<EditOutlined aria-hidden />}
                    onClick={event => {
                      event.stopPropagation();
                      layersEditor.handle.open(layer);
                    }}
                  />
                </Tooltip>,
              ]}
            >
              <List.Item.Meta
                title={layer.name}
                description={`Ruolo: ${roleLabel} — Proprietà: ${competence.identifyingPropertyName}`}
              />
            </List.Item>
          );
        }}
      />
    </div>
  );
}
